// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-match {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
}

.save-match-buttons {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.save-button,
.cancel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  border: none;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 750;
}

.save-button {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

.cancel-button {
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
}

.save-button:disabled,
.cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.public-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: var(--vb-text-muted);
  font-size: 13px;
}

.public-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--vb-primary);
}

.checkbox-label {
  display: flex;
  flex-direction: column;
  font-weight: 650;
  color: var(--vb-text);
}

.checkbox-label small { display: none; }
`, "",{"version":3,"sources":["webpack://./src/components/SaveMatch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,wBAAwB,aAAa,EAAE","sourcesContent":[".save-match {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: transparent;\n  border: none;\n  padding: 0;\n  box-shadow: none;\n}\n\n.save-match-buttons {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.save-button,\n.cancel-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 40px;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.save-button {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\n.cancel-button {\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n}\n\n.save-button:disabled,\n.cancel-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.public-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n}\n\n.public-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--vb-primary);\n}\n\n.checkbox-label {\n  display: flex;\n  flex-direction: column;\n  font-weight: 650;\n  color: var(--vb-text);\n}\n\n.checkbox-label small { display: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
